/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import { useEffect } from 'react';
import { isFormLoading, isIbanValid } from '../../../Signals/formStateSignal';
import { useLazyQuery } from '../../../Hooks/API/useLazyQuery';
import { useCheckoutStore } from '../../../Hooks/Zustand/useCheckoutStore';

export const useIbanValidator = (validateField) => {
  const {
    lazyQuery,
    data,
  } = useLazyQuery('validateIban');
  const { updateFormDataValue } = useCheckoutStore();

  useEffect(() => {
    isFormLoading.value = false;
    if (data && 'validIban' in data) {
      if (data.validIban === true) {
        updateFormDataValue('isIbanValid', true);
        isIbanValid.value = true;
        validateField('iban');
      } else {
        updateFormDataValue('isIbanValid', false);
        isIbanValid.value = false;
        validateField('iban');
      }
    }
  }, [data, updateFormDataValue, validateField]);

  const validateIban = (value) => {
    isFormLoading.value = true;
    lazyQuery({ iban: value });
  };

  return {
    validateIban,
  };
};
